import { RouteConfig } from "vue-router";

const routes: Array<RouteConfig> = [
    {
        path: "/operations/operations/product-scheduling",
        name: "ProductScheduling",
        meta: { title: "Programación y precios" },
        component: () =>
            import(/* webpackChunkName: "operations" */ "../views/Operations/GetProductSchedulingView.vue"),
    }, {
        path: "/operations/operations/product-restrictions",
        name: "ProductRestrictions",
        meta: { title: "Cierre de ventas" },
        component: () =>
            import(/* webpackChunkName: "operations" */ "../views/Operations/GetProductRestrictionsView.vue"),
    }, {
        path: "/operations/operations/day-scheduling",
        name: "DayScheduling",
        meta: { title: "Planificación diaria" },
        component: () =>
            import(/* webpackChunkName: "operations" */ "../views/Operations/GetDaySchedulingView.vue"),
    }, {
        path: "/operations/operations/incidents",
        name: "GetAllIncidents",
        meta: { title: "Incidentes" },
        component: () =>
            import(/* webpackChunkName: "operations" */ "../views/Operations/GetIncidentsView.vue"),
    }, {
        path: "/operations/operations/day-routes",
        name: "GetDayRoutes",
        meta: { title: "Autobuses en ruta" },
        component: () =>
            import(/* webpackChunkName: "operations" */ "../views/Operations/GetDayRoutesView.vue"),
    },
    {
        path: "/operations/operations/work-orders",
        name: "GetAllWorkOrders",
        meta: { title: "Órdenes de trabajo" },
        component: () =>
            import(/* webpackChunkName: "workorders" */ "../views/WorkOrders/GetAllWorkOrdersView.vue"),
    },
    {
        path: "/operations/operations/work-orders/:id",
        name: "ViewWorkOrder",
        meta: { title: "Órdenes de trabajo" },
        component: () =>
            import(/* webpackChunkName: "workorders" */ "../views/WorkOrders/GetWorkOrderView.vue"),
    },
    {
        path: "/operations/operations/guide-preferences",
        name: "GetGuidePreferences",
        meta: { title: "Planificación de guías" },
        component: () =>
            import(/* webpackChunkName: "guide-preferences" */ "../views/Operations/GetGuidePreferencesView.vue"),
    },
];


export default routes;
